export const POLICIES = '[POLICIES]';

// COMMAND ACTIONS
export const FETCH_POLICES = `${POLICIES} FETCH_POLICES`;

// DOCUMENT ACTIONS
export const SET_POLICIES = `${POLICIES} SET_POLICIES`;
export const INSERT_POLICY = `${POLICIES} INSERT_POLICY`;
export const UPDATE_POLICY = `${POLICIES} SET_POLICIES`;

// COMMANDS

export const fetchPolicesCommand = fetchAllPoliciesEndpoint => ({
    type: FETCH_POLICES,
    payload: {meta: {url: fetchAllPoliciesEndpoint}}
});


// ACTIONS

export const setPoliciesAction = (policies = []) => ({
    type: SET_POLICIES,
    payload: {data: policies}
});
